<app-table
  [service]="campaignHashtagService"
  pageFunctionName="getCampaignsList"
  [cols]="cols"
  sortField="title"
  [sortOrder]="-1"
  [defaultRows]="25"
  [actionButtons]="actionButtons"
  (actionButtonClick)="buttonClick($event)"
  (booleanAction)="updateActive($event)"
  [dropdownFilters]="dropdownFilters"
  [addButton]="true"
  addLabel="Incluir campanha"
  addButtonRouterLink="new"
  modelName="campanhas"
  tableTitle="Campanhas"
/>

<p-confirmPopup />
